<script lang="ts" setup>
import { computed } from 'vue';
import type { Coordinates } from '@/api';
import { useSearchFiltersStore } from '@/views/search/searchFiltersStore.ts';
import SubscribeCardBase from '@/views/search/SubscribeCardBase.vue';

const filters = useSearchFiltersStore();

const location = computed<Coordinates | null>(() => {
  const coordinates = filters.autocomplete?.location.coordinates;
  return coordinates
    ? {
        latitude: coordinates.latitude,
        longitude: coordinates.longitude,
      }
    : null;
});

const distance = computed(() => filters.distance);
const categoryIds = computed(() => filters.appliedCategories.map((category) => category.id));
</script>

<template>
  <SubscribeCardBase :category-ids="categoryIds" :distance="distance" :location="location" />
</template>

<style lang="css" scoped></style>
